import { createTreeInsertionController } from './InsertionSharedCode';

// Export BST controller (isAVL = false)
export default createTreeInsertionController(false);